import CompanyCoproducerTable from "../../components/co-producer/CompanyCoproducerTable";


export default function CompanyCoproducer() {
    return (
        <>
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 space-y-6">
                    <CompanyCoproducerTable/>
                </div>
            </div>
        </>
    );
}